import { isHXApp, joinLiveRoom } from "@saas/components";
import { mapGetters } from "vuex";
import { getDiffDate } from "@saas/components/src/utils/utils.js";
import moment from "moment";
import { getUserToken } from "@saas/server-api/src/live-list";
import { getCalendarCourseList } from "@saas/server-api/src/learning-center";
import { MyCalendar } from "@saas/components/src";
import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
export default {
  data: function () {
    return {
      pageLoading: false,
      isHXApp: isHXApp(),
      moment,
      // courseList: [], //全部数据
      showDataList: [], //需要展示的数据
      activeDay: "", //当前选中日期
      activeMounth: "", //当前月份
      needMarkList: [], //需要进行标记处理的数据
      showAll: false,
      noMore: false,
      page_no: 1,
      page_size: 18,
      isLoading: false,
      busy: false,
      scrollBoundary: null,
      isElectron: window.isElectron,
    };
  },
  created() {
    // if (window.isElectron) {
    //   window.ipcRenderer.on("join-live-room-over", this.stopLoading);
    // } else {
    //   window.addEventListener("join-live-room-over", this.stopLoading, true);
    // }
    this.inintData();
  },
  beforeDestroy() {
    // window.removeEventListener("join-live-room-over", this.stopLoading, true);
    // window?.ipcRenderer?.removeListener(
    //   "join-live-room-over",
    //   this.stopLoading
    // );
  },
  mounted() {},
  methods: {
    inintData() {
      this.activeDay = moment().format("YYYY-MM-DD");
      this.activeMounth = moment().format("YYYY-MM");
      let params = {
        begin_at: Math.floor(moment().startOf("month").valueOf() / 1000),
        end_at: Math.floor(moment().endOf("month").valueOf() / 1000),
        page_no: 0,
        page_size: 0,
      };
      this.apiGetCalendarCourseList(params, true, true);
    },
    handleJumpToday() {
      if (
        this.activeDay === moment(new Date()).format("YYYY-MM-DD") &&
        !this.showAll
      ) {
        return;
      } else {
        this.showAll = false;
        this.inintData();
      }
    },
    // stopLoading() {
    //   console.log("stopLoading--2");
    //   this.pageLoading = false;
    // },
    // 直播状态处理
    handleLiveStatus(arr) {
      arr.forEach((item) => {
        // 直播课状态处理
        this.handleLiveTimeStatus(item);
        // 处理直播间状态
        this.handleRoomStatus(item);
        // 提示信息处理
        this.handleLiveTips(item);
      });
    },
    // 处理直播间状态
    handleRoomStatus(item) {
      let { room_start_time, room_end_time } = item;
      if (room_start_time > 0 && !room_end_time) {
        item.roomStatus = 2;
        item.roomStatusText = "上课中";
      } else if (room_end_time > 0) {
        item.roomStatus = 3;
        item.roomStatusText = "已下课";
      } else {
        item.roomStatus = 1;
        item.roomStatusText = "未开始";
      }
    },
    handleLiveTimeStatus(item) {
      let begin = item.live_start_time;
      let end = item.live_end_time;
      let now = new Date().getTime();
      // 可提前进入
      if (item.first_join_time) {
        begin = begin - item.first_join_time * 60;
      }
      if (end * 1000 < now) {
        // 已结束
        item.status = 3;
      } else if (begin * 1000 > now) {
        // 未开始
        item.status = 1;
      } else {
        // 已开始
        item.status = 2;
      }
    },
    // 直播课提示信息
    handleLiveTips(lesson) {
      if (lesson.record_url) {
        lesson.liveStatus = 1;
        lesson.tips = "观看视频";
      } else if (lesson.roomStatus === 3) {
        lesson.liveStatus = 2;
        lesson.tips = "回放生成中";
      } else if (lesson.status === 2 || lesson.roomStatus === 2) {
        // 直播间开始上课|到后台设置的课程开始时间
        lesson.liveStatus = 3;
        lesson.tips = "进入直播";
      } else if (lesson.status === 1 && lesson.first_join_time) {
        lesson.liveStatus = 4;
        lesson.tips = `提前${lesson.first_join_time}分钟可进入教室`;
      }
    },
    // 进入教室
    goLiveRoom(obj) {
      if (obj.liveStatus === 4) {
        this.$showToast("未开始");
      } else if (obj.liveStatus === 2) {
        this.$showToast("回放生成中");
      } else if (obj.liveStatus === 1) {
        let { course_id, lesson_id, unit_id } = obj;
        this.$router.push({
          path: `/video-play/${course_id}/${unit_id}/${lesson_id}`,
        });
      } else {
        // this.pageLoading = true;
        this.$saasLoadingShow();
        let params = {
          course_id: obj.course_id,
          lesson_id: obj.lesson_id,
        };
        getUserToken(params).then((res) => {
          if (res.code === 1) {
            let {
              room_id = "",
              token = "",
              user_id = "",
              risk_control_switch,
              is_teacher = false,
              risk_control_config = {},
            } = res.data;
            let { course_id = "", lesson_id = "", unit_id = "" } = obj;
            const disableRecord =
              risk_control_switch === 1 &&
              risk_control_config.recording_screen_switch === 1
                ? 1
                : 0;
            if (this.isHXApp) {
              let params = {
                room_id,
                user_id,
                course_id,
                lesson_id,
                token,
                disableRecord,
              };
              jsToFlutter("joinLiveRoom", params);
              // this.pageLoading = false;
              this.$saasLoadingClose();
            } else {
              this.$router.push({
                path: `/video-play/${course_id}/${unit_id}/${lesson_id}`,
              });
              this.$saasLoadingClose();
              // joinLiveRoom({
              //   classid: room_id,
              //   userid: user_id,
              //   courseid: course_id,
              //   lessonid: lesson_id,
              //   token: token,
              //   disableRecord: is_teacher ? 0 : disableRecord,
              // });
            }
          } else if (res.code === 40007) {
            // 开启网页防火墙
            this.$router.replace("/firewall/" + obj.course_id);
            // this.pageLoading = false;
            this.$saasLoadingClose();
          } else {
            this.$message.error(res.message);
            // this.pageLoading = false;
            this.$saasLoadingClose();
          }
        });
      }
    },
    apiGetCalendarCourseList(params, needMark = false, handleShow = false) {
      getCalendarCourseList(params).then((res) => {
        if (res.code === 1) {
          let data = res.data?.list || [];
          // 过滤出未结束的课程
          // data = data.filter((item) => {
          //   return !(item.live_end_time * 1000 < new Date().getTime());
          // });
          if (needMark) {
            // 需要进行标记
            this.needMarkList = data;
          }
          if (handleShow) {
            // 处理要展示的数据
            this.handleShowList(data);
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    showAllData() {
      this.activeDay = "";
      this.showAll = true;
      this.showDataList = [];
      this.page_no = 1;
      this.noMore = false;
      this.getAllListBypage();
      let nowMounth = moment().format("YYYY-MM");
      if (nowMounth !== this.activeMounth) {
        // 获取当月数据-只进行标记
        this.handleChangeMonth(moment().format("YYYY-MM"));
      }
    },
    // 全部数据分页加载
    getAllListBypage() {
      let params = {
        page_no: this.page_no,
        page_size: this.page_size,
      };
      getCalendarCourseList(params).then((res) => {
        if (res.code === 1) {
          let data = res.data?.list || [];
          // 过滤出未结束的课程
          // data = data.filter((item) => {
          //   return !(item.live_end_time * 1000 < new Date().getTime());
          // });
          this.showDataList = this.showDataList.concat(data);
          if (this.showDataList.length === res.data.total) {
            this.noMore = true;
          }
          this.handleLiveStatus(this.showDataList);
        } else {
          this.$message.error(res.message);
        }
        this.isLoading = false;
      });
    },
    handleShowList(arr) {
      // 展示全部
      if (this.showAll) {
        this.showDataList = arr;
        this.handleLiveStatus(this.showDataList);
        return false;
      }
      // 展示某天
      let beginTime, endTime;
      if (this.activeDay) {
        beginTime = new Date(this.activeDay).setHours(0, 0, 0);
        endTime = new Date(this.activeDay).setHours(24, 0, 0, 0) - 1000;
      } else {
        // 展示当天
        beginTime = new Date().getTime();
        endTime = new Date().setHours(24, 0, 0, 0) - 1000;
      }
      this.showDataList = arr.filter((item) => {
        return !(
          item.live_end_time * 1000 < beginTime ||
          item.live_start_time * 1000 > endTime
        );
      });
      // 直播状态处理
      this.handleLiveStatus(this.showDataList);
    },
    handleClickDay(data) {
      this.showAll = false;
      this.activeDay = data;
      this.handleShowList(this.needMarkList);
    },
    handleChangeMonth(data) {
      this.activeMounth = data;
      let params = {
        begin_at: Math.floor(
          moment(this.activeMounth).startOf("month").valueOf() / 1000
        ),
        end_at: Math.floor(
          moment(this.activeMounth).endOf("month").valueOf() / 1000
        ),
        page_no: 0,
        page_size: 0,
      };
      this.apiGetCalendarCourseList(params, true);
    },
    // 监听列表滚动
    handleScroll(event) {
      if (!this.showAll || this.noMore || this.isLoading) return false;
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // 触底-加载下一页
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        this.isLoading = true;
        this.page_no++;
        this.getAllListBypage();
      }
    },
  },
  computed: {
    liveInThisYear() {
      return (item) => {
        let { live_start_time } = item;
        let nowYear = new Date().getFullYear();
        let liveYear = new Date(live_start_time * 1000).getFullYear();
        if (nowYear === liveYear) {
          return `<span>${moment(item.live_start_time * 1000).format(
            "MM月DD日"
          )}</span>`;
        } else {
          let styleValue = "font-size:14px";
          if (window.isElectron) {
            styleValue = "font-size:12px";
          } else if (this.isH5) {
            styleValue = "";
          }
          return `<span style="${styleValue}">${moment(
            item.live_start_time * 1000
          ).format("YYYY.MM.DD")}</span>`;
        }
      };
    },
    markDate() {
      let arr = [];
      this.needMarkList.forEach((item) => {
        let stime = moment(item.live_start_time * 1000).format("YYYY-MM-DD");
        let etime = moment(item.live_end_time * 1000).format("YYYY-MM-DD");
        let diffDateArr = getDiffDate(stime, etime);
        arr = arr.concat(diffDateArr);
      });
      // 去重
      arr = Array.from(new Set(arr));
      return arr.map((item) => {
        return {
          date: item,
          className: "mark1",
        };
      });
    },
    ...mapGetters(["user"]),
  },
  components: {
    "my-calendar": MyCalendar,
  },
};
